import { AdminClientProfileViewModel } from '@common/model/client/profile/adminClientProfileViewModel';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import React from 'react';
import { Platform } from '@common/model/platform';

export const platformIcons: Record<Platform, [string, string]> = {
  [Platform.Web]: ['🕸️', 'Web'],
  [Platform.Unknown]: ['❔', 'Неизвестно'],
  [Platform.UnknownMobilePlatform]: ['❔', 'Неизвестно'],
  [Platform.ApiServer]: ['❔', 'ApiServer'],
  [Platform.IOS]: ['🍏', 'Firebase'],
  [Platform.Android]: ['🤖', 'Android'],
};

export interface NotificationSubscriptionsProps extends BoxProps {
  data: AdminClientProfileViewModel['notificationPlatforms'];
}

export const NotificationSubscriptions: React.FC<NotificationSubscriptionsProps> = ({ data, ...restProps }) => {
  return <Box {...restProps}>{data?.map((platform) => platformIcons[platform][0])}</Box>;
};
